import { render, staticRenderFns } from "./AssignedTests.vue?vue&type=template&id=bf6c628c&"
import script from "./AssignedTests.vue?vue&type=script&lang=js&"
export * from "./AssignedTests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports